import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';

export const DepositTransactionPayloadSchema = z
    .object({
        buyer: z.string().optional(),
        payout: z.string().optional(),
        invoice: z.string().optional(),
        checkout: z.string().optional(),
        note: z.string().optional(),
    })
    .strict();

export class DepositTransactionPayload extends FromSchema(DepositTransactionPayloadSchema) {
    buyer?: string;
    payout?: string;
    invoice?: string;
    checkout?: string;
    note?: string;
}
